module.exports = __webpack_public_path__ + "static/media/map-image.11a56ecd.png";